var map = {
	"./angular.svg": "a435",
	"./angularmaterial.png": "693c",
	"./angularmaterial.png.webp": "5018",
	"./bootstrap.svg": "2fc0",
	"./css.svg": "9ffc",
	"./discord.svg": "56c4",
	"./docker.svg": "303f",
	"./es6.svg": "98df",
	"./firebase.svg": "b08a",
	"./flutter.svg": "7b99",
	"./github.svg": "5710",
	"./greensock.png": "5697",
	"./greensock.png.webp": "886c",
	"./html.svg": "65c3",
	"./materialize.svg": "8d7a",
	"./mysql.svg": "8abc",
	"./nodejs.svg": "6d45",
	"./php.svg": "7f2d",
	"./prisma.svg": "55d2",
	"./pwa.svg": "43f3",
	"./python.svg": "e3fa",
	"./react.svg": "eb85",
	"./sequelize.svg": "1815",
	"./symfony.png": "d653",
	"./symfony.png.webp": "d615",
	"./vuejs.svg": "425d",
	"./vuetify.svg": "0d1c",
	"./zbook.png": "1d7e",
	"./zbook.png.webp": "296e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "35f9";